import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";

export default function SectionNav({ title = "Menu", items = [] }) {
  const history = useHistory();
  const location = useLocation();

  const isActive = (item) => {
    if (!item?.path) return false;
    return (
      location.pathname === item.path ||
      location.pathname.startsWith(item.path + "/")
    );
  };

  return (
    <Box
      sx={{
        width: { xs: "100%", md: 260, lg: 280 },
        minWidth: { xs: "100%", md: 260, lg: 280 },
        flexShrink: 0,
        borderRight: { xs: "none", md: "1px solid #e5e7eb" },
        borderBottom: { xs: "1px solid #e5e7eb", md: "none" },
        bgcolor: "#ffffff",
        p: { xs: 1, md: 1.5 },
        boxSizing: "border-box",
      }}
    >
      <Typography
        sx={{
          display: { xs: "none", md: "block" },
          fontSize: "0.9rem",
          fontWeight: 700,
          color: "#111827",
          mb: 1.5,
          px: 1,
          letterSpacing: "-0.01em",
        }}
      >
        {title}
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "row", md: "column" },
          alignItems: { xs: "center", md: "stretch" },
          gap: 0.75,
          overflowX: { xs: "auto", md: "visible" },
          pb: { xs: 0.5, md: 0 },
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        {items.map((item) => (
          <Button
            key={item.path || item.label}
            onClick={() => history.push(item.path)}
            sx={{
              flexShrink: { xs: 0, md: 1 },
              display: "block",
              width: { xs: "auto", md: "100%" },
              justifyContent: "flex-start",
              textAlign: "left",
              textTransform: "none",
              borderRadius: 2,
              px: 1.35,
              py: 0.95,
              minWidth: { xs: "max-content", md: 0 },
              color: isActive(item) ? "#0f172a" : "#374151",
              bgcolor: isActive(item) ? "#eaf2ff" : "transparent",
              fontSize: { xs: "0.86rem", md: "0.9rem" },
              fontWeight: isActive(item) ? 700 : 500,
              lineHeight: 1.25,
              whiteSpace: { xs: "nowrap", md: "normal" },
              overflowWrap: "anywhere",
              wordBreak: "normal",
              "&:hover": {
                bgcolor: isActive(item) ? "#eaf2ff" : "#f1f5f9",
              },
            }}
          >
            {item.label}
          </Button>
        ))}
      </Box>
    </Box>
  );
}